import { get } from 'common/utils/request';
export var fetchCustomizationsApi = function () {
    return get('/companies/self/customization');
};
